import i18n from '@shared/config/i18n';

const { t } = i18n;

export default class ValidatedRequest {
  constructor(request) {
    this._request = request;
  }

  request() {
    return this._request;
  }

  async send() {
    let response;

    try {
      response = await this._request.send();
    } catch (error) {
      throw new Error(t('UnknownErrorTryLater'));
    }

    if (Object.prototype.hasOwnProperty.call(response.data.service, 'error')) {
      throw new Error(response.data.service.error.message || t('UnknownErrorTryLater'));
    }

    return response.data;
  }
}
